import styled from 'styled-components';

import profileAvatarDefaultImage from '../../../assets/images/profile-avatar-default.png';
import { resolveRenderableAvatarUrl } from '../../../shared/model';
import { ProfileRating, ProfileSummaryCard } from '../../../shared/ui';

type MyPageProfilePreviewCardProps = {
  avatarUrl?: string | null;
  goalText: string;
  isRatingVisible: boolean;
  profileName: string;
  previewProgressLabel: string;
  previewProgressPercent: number;
  ratingValueLabel: string;
};

const Avatar = styled.img.attrs({
  alt: '',
  'aria-hidden': true,
})`
  width: ${({ theme }) => theme.scale.px(74)};
  height: ${({ theme }) => theme.scale.px(74)};
  border-radius: 50%;
  object-fit: cover;
  display: block;
`;

export function MyPageProfilePreviewCard({
  avatarUrl = null,
  goalText,
  isRatingVisible,
  profileName,
  previewProgressLabel,
  previewProgressPercent,
  ratingValueLabel,
}: MyPageProfilePreviewCardProps) {
  const avatarSource =
    resolveRenderableAvatarUrl(avatarUrl) ?? profileAvatarDefaultImage;

  return (
    <ProfileSummaryCard
      avatar={<Avatar src={avatarSource} />}
      dataUi="my-page-profile-preview-card"
      goalText={goalText}
      profileName={profileName}
      progressLabel={previewProgressLabel}
      progressPercent={previewProgressPercent}
      ratingSlot={
        isRatingVisible ? (
          <ProfileRating
            dataUi="my-page-profile-rating-stars"
            starSizePx={12}
            valueFontSizePx={14}
            valueLabel={ratingValueLabel}
            valueTone="subdued"
          />
        ) : null
      }
    />
  );
}
